import styles from './BrandLockup.module.css'

type BrandLockupVariant = 'nav' | 'auth'

interface BrandLockupProps {
  meta?: string
  variant?: BrandLockupVariant
}

export function BrandLockup({ meta, variant = 'nav' }: BrandLockupProps) {
  const label = meta ? `Tasamago. ${meta}.` : 'Tasamago'

  return (
    <span className={`${styles.root} ${styles[variant]}`} aria-label={label}>
      <span className={styles.darkBrand} aria-hidden="true">
        <img src="/brand/logomark.png" alt="" className={styles.logomark} />
        <span className={styles.brandName}>Tasamago</span>
      </span>
      <img
        src="/brand/wordmark-horizontal.png"
        alt=""
        className={styles.lightWordmark}
        aria-hidden="true"
      />
      {meta && <span className={styles.meta} aria-hidden="true">{meta}</span>}
    </span>
  )
}
